import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';

import { inEditorUserContentDecorationPluginKey } from './in-editor-user-content-decoration-plugin-key';

export type InEditorUserContentDecorationPluginState = {
	userContentPositions?: [number, number];
	aiContentPositions?: [number, number];
	selectionPositions?: [number, number];
	isFinalStream?: boolean;
};

export const createInEditorUserContentDecorationPlugin = (
	initialUserContentPositions?: [number, number],
) =>
	new SafePlugin<InEditorUserContentDecorationPluginState>({
		key: inEditorUserContentDecorationPluginKey,
		state: {
			init: () => {
				return {
					isFinalStream: false,
					userContentPositions: initialUserContentPositions,
				};
			},
			apply: (tr, pluginState) => {
				const meta = tr.getMeta(inEditorUserContentDecorationPluginKey);
				if (meta && meta?.action === 'updatePositions') {
					const { userContentPositions, aiContentPositions, selectionPositions, isFinalStream } =
						meta;
					return {
						userContentPositions,
						aiContentPositions,
						selectionPositions,
						isFinalStream,
					};
				}
				return pluginState;
			},
		},
	});
